import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import StickyCTA from "./StickyCTA";
import Footer from "@/pages/home/components/Footer";

interface PageLayoutProps {
  eyebrow: string;
  title: ReactNode;
  intro: string;
  children: ReactNode;
}

export default function PageLayout({ eyebrow, title, intro, children }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar solid />
      <main className="pt-20 md:pt-24">
        <div className="px-4 md:px-6 lg:px-10 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase border border-foreground-200/60 px-3 py-1 rounded-full mb-4">
              {eyebrow}
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight mb-4 max-w-3xl">
              {title}
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              {intro}
            </p>
          </div>
        </div>

        {children}

        {/* Conversion banner */}
        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-foreground-950">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2">
                Ready for a good ride?
              </h2>
              <p className="text-background-400 text-sm">
                Free quote, response within the hour. 24/7 across Los Angeles.
              </p>
            </div>
            <Link
              to="/#reservation"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <span>Book Your Ride</span>
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
